import GoCardlessLegal from './GoCardlessLegal';

export default GoCardlessLegal;
